var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79998 3.8001V3.0001C3.79998 1.67461 4.87449 0.600098 6.19998 0.600098H7.79998C9.12546 0.600098 10.2 1.67461 10.2 3.0001V3.8001H11.8C12.6836 3.8001 13.4 4.51644 13.4 5.4001V8.25671C11.4077 8.99588 9.25188 9.40005 7 9.40005C4.74809 9.40005 2.59227 8.99588 0.599976 8.25669V5.4001C0.599976 4.51644 1.31632 3.8001 2.19998 3.8001H3.79998ZM5.39998 3.0001C5.39998 2.55827 5.75815 2.2001 6.19998 2.2001H7.79998C8.2418 2.2001 8.59998 2.55827 8.59998 3.0001V3.8001H5.39998V3.0001ZM6.19998 7.0001C6.19998 6.55827 6.55815 6.2001 6.99998 6.2001H7.00798C7.4498 6.2001 7.80798 6.55827 7.80798 7.0001C7.80798 7.44193 7.4498 7.8001 7.00798 7.8001H6.99998C6.55815 7.8001 6.19998 7.44193 6.19998 7.0001Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599976 9.9539V11.8001C0.599976 12.6838 1.31632 13.4001 2.19998 13.4001H11.8C12.6836 13.4001 13.4 12.6838 13.4 11.8001V9.95392C11.3898 10.6325 9.2371 11.0001 7 11.0001C4.76288 11.0001 2.61021 10.6324 0.599976 9.9539Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.66cef8ce1265b7cf6dcfced33b6aa9c8.svg";
export { ForwardRef as ReactComponent };